"use strict";var e=require("react");exports.useCallbackRef=function(a,r){var c=e.useState((function(){return{value:a,callback:r,facade:{get current(){return c.value},set current(e){var a=c.value;a!==e&&(c.value=e,c.callback(e,a))}}}}))[0];return c.callback=r,c.facade};
//# sourceMappingURL=useRef.js.map
